import moment from "moment";
import { SENTIMENT_ACTION } from "./actions";
import { IData } from "../web/common";
import klineInterval from "../Params";

const DATA_COUNT = 208;
const COLLECTION_NAME = "NS_CRP_LINES_500";

interface IXUData {
  lines500: IData[];
  requested: boolean;
  loaded: boolean;
  lastUpdate: number;
}

const initialState: IXUData = {
  lines500: [],
  requested: false,
  loaded: false,
  lastUpdate: 0
};

export function loadLines500Snapshot(firebase: any, period: number) {
  if (period < 0 || ![0, 10, 30, 99].includes(period)) {
    console.log("Invalid period for line 500. Period:", period);
    return async function thunk(dispatch: any, getState: any) {
      dispatch({
        type: SENTIMENT_ACTION.EMPTY_ACTION,
        payload: {},
      });
    };
  }
  return async function thunk(dispatch: any, getState: any) {
    const state = getState();
    if (new Date().getTime()-state.Lines500Snapshot.lastUpdate<60*1000) return;

    dispatch({
      type: SENTIMENT_ACTION.LINES_500_SNAPSHOT,
      payload: { requested: true, loaded: false, sentiment: [] },
    });

    firebase
      .firestore()
      .collection(`${COLLECTION_NAME}${klineInterval}_P${period}`)
      .orderBy("dateTime", "desc")
      .limit(DATA_COUNT)
      .get().then((querySnapshot: any) => {
        var lines500Data: Object[] = [];

        querySnapshot.forEach(function (doc: any) {
          //if (lines500Data.some((x: any) => { x.Symbol == doc.data().symbol })) return;

          lines500Data.push({
            name: "lines500",
            Index: doc.data().index,
            Symbol: doc.data().symbol,
            Sentiment: doc.data().sentiment,
            Order: doc.data().order,
            Grup: doc.data().grup,
            ODate: doc.data().openDate,
            OPrice: doc.data().openPrice,
            Price: doc.data().price,
            DailyChange: doc.data().dailyChange,
            Vbts: doc.data().vbts,
            Viop: doc.data().viop,
            PerDay: doc.data().perDay,
            SentimentList: doc.data().sentimentList,
            PriceList: doc.data().priceList,
            ChangeList: doc.data().changeList,
            ChangeList3: doc.data().changeList3,
            ChangeList4: doc.data().changeList4,
            ChangeList5: doc.data().changeList5,
            ChangeList6: doc.data().changeList6,
            ChangeList7: doc.data().changeList7,
            ReChangeList: doc.data().changeList.slice().reverse(),
            dateTime: doc.data().dateTime.toDate(),
            Time: doc.data().time ?? 0,
            UpdateTime: moment
              .unix(doc.data().dateTime.seconds)
              .format("DD.MM.yy HH:mm"),
            LineDate: doc.data().dateTime.seconds,
            STP: doc.data().vwma?.reverse(),
          });
        });
        dispatch({
          type: SENTIMENT_ACTION.LINES_500_SNAPSHOT,
          payload: {
            lines500: lines500Data.sort((a: any, b: any) => { return a.Order - b.Order }),
            loaded: true,
            requested: true,
            lastUpdate:new Date().getTime()
          },
        });
      });
  };
}

export default function Lines500Snapshot(state = initialState, action: any) {
  switch (action.type) {
    case SENTIMENT_ACTION.LINES_500_SNAPSHOT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
export const lines500SnapshotSelector = (state: any) => state.Lines500Snapshot;
